import React from 'react'
import { ArrowLeft, Home } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

const NavbarSimple: React.FC = () => {
	const navigate = useNavigate()

	const handleBack = () => {
		navigate(-1)
	}

	const handleHome = () => {
		navigate('/')
	}

	return (
		<div className='w-full h-[10vh] min-h-[60px] px-4 py-2 md:px-8 md:py-4 bg-gray-50 shadow-md flex justify-between items-center relative overflow-hidden'>
			<div className='absolute inset-0 opacity-5'>
				<div
					className='absolute inset-0'
					style={{
						backgroundImage: `url("data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23dc2626' fill-opacity='0.1'%3E%3Ccircle cx='20' cy='20' r='1'/%3E%3C/g%3E%3C/svg%3E")`,
					}}
				/>
			</div>

			<div className='flex items-center space-x-3 relative z-10'>
				<div className='w-10 h-10 md:w-12 md:h-12 flex items-center justify-center'>
					<img
						src='/logo.png'
						alt='SportCenter Logo'
						className='w-full h-full object-contain'
					/>
				</div>

				<div className='flex flex-col'>
					<h1 className='text-lg md:text-2xl xl:text-3xl font-black text-gray-900 tracking-tight leading-none'>
						<span className='text-red-600'>Sport</span>Center
					</h1>
					<p className='text-xs text-gray-500 font-medium -mt-0.5 tracking-wide'>
						SHOP
					</p>
				</div>
			</div>

			<div className='flex items-center gap-2 md:gap-3 relative z-10'>
				<button
					onClick={handleHome}
					className='group relative bg-white/80 backdrop-blur-sm hover:bg-white border border-gray-200 hover:border-green-200 shadow-sm hover:shadow-lg p-2.5 md:p-3 rounded-xl hover:rounded-lg transition-all duration-300 ease-out hover:scale-105 active:scale-95 focus:outline-none focus:ring-2 focus:ring-green-500/20 focus:ring-offset-1 cursor-pointer'
					aria-label='Ir al inicio'
				>
					<div className='absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-xl group-hover:rounded-lg'></div>
					<Home className='relative w-5 h-5 md:w-6 md:h-6 text-gray-600 group-hover:text-green-600 transition-all duration-300 group-hover:scale-110' />
					<div className='absolute -inset-1 bg-green-500/10 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 -z-10'></div>
				</button>

				<button
					onClick={handleBack}
					className='group relative bg-white/80 backdrop-blur-sm hover:bg-white border border-gray-200 hover:border-red-200 shadow-sm hover:shadow-lg p-2.5 md:p-3 rounded-xl hover:rounded-lg transition-all duration-300 ease-out hover:scale-105 active:scale-95 focus:outline-none focus:ring-2 focus:ring-red-500/20 focus:ring-offset-1 cursor-pointer'
					aria-label='Volver atrás'
				>
					<div className='absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-xl group-hover:rounded-lg'></div>
					<ArrowLeft className='relative w-5 h-5 md:w-6 md:h-6 text-gray-600 group-hover:text-red-600 transition-all duration-300 group-hover:-translate-x-0.5' />
					<div className='absolute -inset-1 bg-red-500/10 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 -z-10'></div>
				</button>

				<div className='absolute top-full mt-2 left-1/2 transform -translate-x-1/2 bg-gray-900 text-white text-xs px-2 py-1 rounded-md opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none whitespace-nowrap hidden md:block'>
					Volver atrás
					<div className='absolute -top-1 left-1/2 transform -translate-x-1/2 w-2 h-2 bg-gray-900 rotate-45'></div>
				</div>
			</div>
		</div>
	)
}

export default NavbarSimple
